import React, { useState } from "react";
import Button from "@mui/material/Button";
import { Box, Checkbox, DialogActions, DialogContent, DialogTitle, Typography, FormControlLabel } from "@mui/material";
import MuiDialog from "@mui/material/Dialog";
import CloseIcon from "@mui/icons-material/Close";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import { withTranslation } from "react-i18next";
import { isEmpty } from "lodash";
import { ModalRule } from "@plannel/components/modal/BaseConfigModal";
import { FS } from "@plannel/utils/font-util";

/*
 * 삭제 옵션(연쇄 삭제) 확인 다이얼로그. components/Dialog.js 의 형제다 —
 * 겉모습을 설정 모달 셸(BaseConfigModal)과 같은 규격으로 맞춰 둔다.
 */

const DeleteOptionDialog = (props) => {
  const { open, title, content, onConfirm, onClose, t } = props;
  const [shouldCascade, setShouldCascade] = useState(false);

  const handleConfirm = () => {
    onConfirm(shouldCascade);
    onClose();
    setShouldCascade(false);
  };

  const handleCancel = () => {
    onClose();
    setShouldCascade(false);
  };

  const handleOptionChange = (event) => {
    setShouldCascade(event.target.checked);
  };

  const Linebreak = (msg) => {
    if (isEmpty(msg)) {
      return "";
    }

    return msg.split(/\r\n|\r|\n/)
      .filter(item => !isEmpty(item))
      .map((str, index) => <div key={`${str}-${index}`}> {str}<br /></div>)
  };

  return (
    <MuiDialog open={open} onClose={handleCancel} fullWidth maxWidth="sm"
      PaperProps={{ sx: { borderRadius: 2 } }}>
      <DialogTitle sx={{ fontSize: FS.DISPLAY, fontWeight: 700, pl: 2, pb: 1 }}>{isEmpty(title) ? "" : t(title)}</DialogTitle>
      <ModalRule />
      <DialogContent sx={{ px: 2, py: 2, fontSize: FS.TITLE }}>
        <Box>
          {Linebreak(content)}
        </Box>
        <FormControlLabel
          control={
            <Checkbox
              color="primary"
              name="shouldCascade"
              checked={shouldCascade}
              onChange={handleOptionChange}
            />
          }
          label={t("MSG_CascadeDelete")}
          sx={{ mt: 2 }}
        />
        <Typography sx={{ fontSize: FS.BODY, color: "text.secondary" }}>{t("MSG_UncheckedDescription")}</Typography>
      </DialogContent>
      <ModalRule />
      <DialogActions sx={{ px: 2, py: 1.5 }}>
        <Button size="small" startIcon={<CloseIcon />} onClick={handleCancel}>{t("cancel")}</Button>
        <Button size="small" variant="contained" disableElevation startIcon={<DoneAllIcon />}
          sx={{ minWidth: 72 }} onClick={handleConfirm}>{t("ok")}</Button>
      </DialogActions>
    </MuiDialog>
  );
};

export default withTranslation()(DeleteOptionDialog);
